import "babel-polyfill";
import Vue from "vue";
import router from "./router";
import axios from "axios";
import Example from "./components/DyExample/install";
import iBee from "ibee";
import "ibee/lib/theme-default/index.css";
import App from "./App";
import { Picker, Popup, Step, Steps, Dialog, Loading, List } from "vant";
import "vant/lib/picker/style";
import "vant/lib/popup/style";
import "vant/lib/step/style";
import "vant/lib/steps/style";
import "vant/lib/dialog/style";
import "vant/lib/loading/style";
import "vant/lib/list/style";

import Global from "../src/assets/js/globalData";
// import Vconsole from "vconsole";
// let vConsole = new Vconsole();

Vue.use(Example);
Vue.use(iBee);
Vue.use(Picker)
  .use(Popup)
  .use(Step)
  .use(Steps)
  .use(Dialog)
  .use(Loading)
  .use(List);
// Vue.use(vConsole);
axios.defaults.baseURL = "api";

Vue.prototype.axios = axios;
Vue.prototype.agentId = "1000008";
Vue.prototype.appId = "wxd44cd8168b0b0113";
Vue.prototype.showLoadding = false;
Vue.prototype.Global = Global;
// 网页授权的回调地址
Vue.prototype.redirectUrl = "https://mee.dongfeng-nissan.com.cn/";

// Vue.prototype.redirectUrl = 'http://www.oneinlet.com:9000/'

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: {
    App
  },
  axios,
  router,
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js